import {Button} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import FileInput from "../../system/fileInput";
import "../../../style/datePicker.css"
import {updateAgentRequestFile} from "../../../services/agent/agent_request"
import Validator from "../../../helper/validator/Validator";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import {checkAll} from "../../../helper/validator/Check";
import {AgentRequestContext} from "../../../context/agent_context";
import {toast} from "react-toastify";
import {AgentRequestTermsModal} from "./agent_request_terms_modal";
import {
  agentRequestFieldClass,
  agentRequestPrimaryButtonClass,
  agentRequestSecondaryButtonClass,
} from "./ui";

export function AgentRequestFile() {

  const {
    setActiveStep,
    agentRequest,
    setAgentRequest,
    handlePrev,
    isFirstStep,
    setAgentLog,
  } = useContext(AgentRequestContext)

  const [degreeFile, setDegreeFile] = useState({name: ""})
  const [degreeFileName, setDegreeFileName] = useState("")
  const [resumeFile, setResumeFile] = useState({name: ""})
  const [resumeFileName, setResumeFileName] = useState("")
  const [introductionFile, setIntroductionFile] = useState(null)

  const [isChecked, setIsChecked] = useState(false)
  const [termsModalOpen, setTermsModalOpen] = useState(false)
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    setDegreeFileName(degreeFile['name'])
  }, [degreeFile]);

  useEffect(() => {
    setResumeFileName(resumeFile['name'])
  }, [resumeFile]);

  useEffect(() => {
    if (!agentRequest || !agentRequest.id) {
      return
    }
    setAgentRequest(agentRequest);
    setDegreeFile((agentRequest?.degree_file) ?? {name: ""});
    setResumeFile((agentRequest?.resume_file) ?? {name: ""});
    setIntroductionFile(agentRequest?.introduction_file ?? null);
  }, []);

  const applicantInfo = [
    {
      label: "نام مشاور",
      value: `${agentRequest?.name ?? ""} ${agentRequest?.family ?? ""}`.trim(),
    },
    {
      label: "کد ملی / شناسه ملی",
      value: agentRequest?.national_code,
    },
    {
      label: "نشانی کامل",
      value: agentRequest?.address,
    },
    {
      label: "شماره تماس",
      value: agentRequest?.home_phone,
    },
    {
      label: "پست الکترونیک",
      value: agentRequest?.email,
    },
  ];

  const validateFiles = () => {
    setIsChecked(true)
    const res = checkAll();
    if (!res) {
      toast.error("مقادیر الزامی را بر اساس راهنما تکمیل کنید")
      return false
    }
    return true
  };

  const openTermsModal = () => {
    if (!validateFiles()) {
      return
    }
    setTermsModalOpen(true)
  };

  const save = async () => {
    if (!termsAccepted) {
      toast.error("پذیرش قوانین همکاری مشاوران الزامی است")
      return
    }

    const data = {
      id: agentRequest.id,
      degree_file: degreeFile ?? agentRequest.degree_file,
      resume_file: resumeFile ?? agentRequest.resume_file,
      terms_accepted: true,
    };

    if (introductionFile) {
      data.introduction_file = introductionFile;
    }

    let result;

    try {
      setSubmitting(true)
      result = await updateAgentRequestFile(data);
    } finally {
      setSubmitting(false)
    }

    if (result.status === 200) {
      setAgentLog(
        {
          agent_id: agentRequest.id,
          status: "new",
        }
      )
      setTermsModalOpen(false)
      setActiveStep(0)
    }
  };

  return (
    <ValidatorProvider>
      <>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">

          <div className={agentRequestFieldClass}>
            <FileInput
              id="agent-degree-file"
              modern
              label={Dict('degree_file')}
              fileCode={degreeFile}
              onChange={(e) => {
                setDegreeFile(e.target.files[0]);
              }}/>
            <Validator isChecked={isChecked} state={degreeFile ?? degreeFileName} rules="required"/>
          </div>

          <div className={agentRequestFieldClass}>
            <FileInput
              id="agent-resume-file"
              modern
              label={Dict('resume_file')}
              fileCode={resumeFile}
              onChange={(e) => {
                setResumeFile(e.target.files[0]);
              }}/>
            <Validator isChecked={isChecked} state={resumeFile ?? resumeFileName} rules="required"/>
          </div>

          <div className={`${agentRequestFieldClass} lg:col-span-2`}>
            <FileInput
              id="agent-introduction-file"
              modern
              label={`${Dict('introduction_file')} (اختیاری)`}
              fileCode={introductionFile}
              onChange={(e) => {
                setIntroductionFile(e.target.files[0]);
              }}/>
          </div>

        </div>
        <div className="mt-7 border-t border-app-border pt-4">
          <div className="flex flex-col gap-3 sm:flex-row sm:justify-between">
            <Button className={`w-full sm:w-auto ${agentRequestPrimaryButtonClass}`} onClick={openTermsModal}>
              ارسال جهت بررسی
            </Button>
            <Button variant="outlined" className={`w-full sm:w-auto ${agentRequestSecondaryButtonClass}`} onClick={() => {
              handlePrev(2)
            }} disabled={isFirstStep}>
              مرحله قبلی
            </Button>
          </div>
        </div>
        <AgentRequestTermsModal
          open={termsModalOpen}
          setOpen={setTermsModalOpen}
          applicantInfo={applicantInfo}
          termsAccepted={termsAccepted}
          setTermsAccepted={setTermsAccepted}
          submitting={submitting}
          onSubmit={save}
        />
      </>
    </ValidatorProvider>
  )
    ;
}
